// extracted by mini-css-extract-plugin
export default {"bodyMainText":"logoConfiguration_bodyMainText__a-id+","dividerLine":"logoConfiguration_dividerLine__oejGd","navigateBtnCol":"logoConfiguration_navigateBtnCol__6Zg60"};